module.exports = __webpack_public_path__ + "img/school8.c4d32c88.png";